(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dice-fights-hero-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = () => {
    document.querySelectorAll('[data-df-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryInitialized) return;
      const track = gallery.querySelector('[data-df-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-df-gallery-slide]')];
      if (!track || !slides.length) return;
      gallery.dataset.galleryInitialized = 'true';
      const selectors = [...gallery.querySelectorAll('[data-df-gallery-index]')];
      const counter = gallery.querySelector('[data-df-gallery-current]');
      const announcement = gallery.querySelector('[data-df-gallery-announcement]');
      let index = 0;
      let frame = 0;
      let announceTimer;
      const update = (next, announce = false) => {
        index = Math.max(0, Math.min(slides.length - 1, next));
        slides.forEach((slide, position) => {
          slide.setAttribute('aria-hidden', String(position !== index));
          slide.inert = position !== index;
        });
        selectors.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.dfGalleryIndex) === index)));
        if (counter) counter.textContent = String(index + 1);
        if (announce && announcement) {
          window.clearTimeout(announceTimer);
          announceTimer = window.setTimeout(() => { announcement.textContent = announcement.dataset.message.replace('[current]', String(index + 1)); }, 150);
        }
      };
      const go = (next, instant = false) => {
        update((next + slides.length) % slides.length, !instant);
        if (track.clientWidth) track.scrollTo({left:index * track.clientWidth,behavior:instant || reducedMotion.matches ? 'instant' : 'smooth'});
      };
      gallery.querySelector('[data-df-gallery-prev]')?.addEventListener('click', () => go(index - 1));
      gallery.querySelector('[data-df-gallery-next]')?.addEventListener('click', () => go(index + 1));
      selectors.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.dfGalleryIndex))));
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          if (track.clientWidth) update(Math.round(track.scrollLeft / track.clientWidth), true);
        });
      }, {passive:true});
      gallery.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      gallery.addEventListener('df:gallery:show', () => {
        window.clearTimeout(announceTimer);
        if (announcement) announcement.textContent = '';
        go(Number(gallery.dataset.startIndex || 0), true);
      });
      const resize = new ResizeObserver(() => { if (track.clientWidth) go(index, true); });
      resize.observe(track);
      gallery.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        resize.disconnect();
        window.cancelAnimationFrame(frame);
        window.clearTimeout(announceTimer);
      }, {once:true});
      update(0);
    });
    document.querySelectorAll('[data-df-gallery-open]').forEach(opener => {
      if (opener.dataset.galleryOpenerInitialized) return;
      const dialog = document.getElementById(opener.dataset.dfGalleryOpen);
      if (!dialog) return;
      opener.dataset.galleryOpenerInitialized = 'true';
      opener.addEventListener('click', () => {
        const status = dialog.querySelector('[data-df-accessory-status]');
        if (status) { status.hidden = true; status.textContent = ''; }
        dialog.showModal();
        dialog.querySelector('[data-df-gallery]')?.dispatchEvent(new CustomEvent('df:gallery:show'));
      });
      dialog.querySelector('[data-df-gallery-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dice-fights-setup"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-df-setup]').forEach(setup => {
    if (setup.dataset.setupInitialized) return;
    setup.dataset.setupInitialized = 'true';
    const tabs = [...setup.querySelectorAll('[data-df-setup-tab]')];
    const panels = [...setup.querySelectorAll('[data-df-setup-panel]')];
    const select = (name, focus = false) => {
      tabs.forEach(tab => {
        const active = tab.dataset.dfSetupTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.dfSetupPanel !== name; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.dfSetupTab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(tabs[next].dataset.dfSetupTab, true);
      });
    });
    setup.querySelector('[data-df-explore-bundles]')?.addEventListener('click', () => {
      select('bundles', true);
      setup.querySelector('.df-setup-tabs').scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dod-delivery-date"] && !Shopify.designMode) return;
  try {
    function dodObservedHoliday(year, month, day) {
    const date = new Date(year, month, day, 12);
    if (date.getDay() === 6) date.setDate(date.getDate() - 1);
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);
    return date;
  }
  function dodBusinessDay(date) {
    if (date.getDay() === 0 || date.getDay() === 6) return false;
    const year = date.getFullYear();
    const holidays = [[0,1],[5,19],[6,4],[10,11],[11,25]].map(([month,day]) => dodObservedHoliday(year,month,day));
    holidays.push(dodObservedHoliday(year+1,0,1));
    const nth = (month, weekday, n) => { const d = new Date(year,month,1,12); d.setDate(1+(weekday-d.getDay()+7)%7+7*(n-1)); return d; };
    holidays.push(nth(0,1,3),nth(1,1,3),nth(8,1,1),nth(9,1,2),nth(10,4,4));
    const memorial = new Date(year,5,0,12); memorial.setDate(memorial.getDate()-(memorial.getDay()+6)%7); holidays.push(memorial);
    return !holidays.some(holiday => holiday.toDateString() === date.toDateString());
  }
  function dodAddBusinessDays(start, count) {
    const date = new Date(start); date.setHours(12,0,0,0);
    while (count > 0) { date.setDate(date.getDate()+1); if (dodBusinessDay(date)) count--; }
    return date;
  }

  function updateDodDeliveryDates() {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const arrival = dodAddBusinessDays(new Date(Number(values.year), Number(values.month) - 1, Number(values.day), 12), 6);
    const formatted = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'short', day: 'numeric' }).format(arrival);
    document.querySelectorAll('[data-dod-delivery-date]').forEach(element => {
      const message = element.dataset.message.replace('[date]', formatted);
      if (element.textContent !== message) element.textContent = message;
    });
  }
  const deliveryObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-dod-delivery-date]') || node.querySelector('[data-dod-delivery-date]'))))) updateDodDeliveryDates();
  });
  deliveryObserver.observe(document.documentElement, { childList: true, subtree: true });
  updateDodDeliveryDates();
  document.addEventListener('DOMContentLoaded', updateDodDeliveryDates);
  document.addEventListener('shopify:section:load', updateDodDeliveryDates);
  window.addEventListener('pageshow', updateDodDeliveryDates);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateDodDeliveryDates();
  });
  } catch(e) { console.error(e); }
})();

})();
